import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from '@shared/services/auth-state.service';

/**
 * Guard que verifica si el usuario está autenticado.
 * Si el usuario no tiene sesión activa, redirige al home.
 */
export const authGuard: CanActivateFn = () => {
  const state = inject(AuthStateService);
  const router = inject(Router);

  // Verificar si hay una sesión activa (usuario logueado)
  const hasSession = state.session() !== null && state.accessToken() !== null;

  if (!hasSession) {
    router.navigate(['/home']);
    return false;
  }

  return true;
};
